import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import reducer from './reducer';
import initialState from './initialState';
import MyApp from './my-app/container';
import SocketService from './services/socket.service';
import SubscribeSockets from './services/subscribe-sockets.service';
import thunk from 'redux-thunk';
import { isLoggedIn } from './actions/user';
import tracking from './shared/tracking';

console.log(`Started ${JSON.stringify(process.env.NODE_ENV)}`);
const middlewares: any[] = [thunk, tracking];

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js');
}

if (process.env.NODE_ENV !== 'production') {
  const logger = createLogger({ level: 'info', collapsed: true });
  middlewares.push(logger);
}

const store = createStore(reducer, initialState, compose(applyMiddleware(...middlewares)));

store.dispatch(isLoggedIn());

SubscribeSockets(store.dispatch, store.getState);

render(
  <Provider store={store}>
    <MyApp />
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.tsx